module.exports = __webpack_public_path__ + "media/images/rank_02-a684984f047156e8edafc0b2403ac125.png";